<template>
  <div>
    <div class="headline primary--text mb-3">Number of Case Status</div>
    <v-layout :style="{ margin: '-8px' }" wrap>
      <v-flex v-for="(item, index) in items" :key="index" class="pa-2" xs12 sm6 md3 lg2>
        <v-card
          :style="{ height: '100% !important', backgroundColor: resolvedBackGroundColor(item) }"
        >
          <v-layout column :style="{ height: 'inherit' }">
            <v-flex shrink>
              <v-card-title class="resize-header">{{ item.text }}</v-card-title>
            </v-flex>
            <v-spacer></v-spacer>
            <v-flex shrink>
              <v-card-text class="resize-value">
                <template v-if="loading">
                  <v-progress-circular color="primary" indeterminate></v-progress-circular>
                </template>
                <template v-else>
                  {{ item.value }}
                </template>
              </v-card-text>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  props: {
    statusStatisticData: {
      type: Object,
      default: () => ({
        answered: 0,
        pending: 0,
        closed: 0,
        cancelled: 0,
        cancelled_by_customer: 0,
        cold_case: 0,
        success: 0,
        closed_by_system: 0,
        closed_with_survey: 0,
        closed_without_survey: 0
      })
    },
    loading: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  computed: {
    items() {
      return [
        {
          text: 'Pending',
          value:
            this.statusStatisticData && this.statusStatisticData.pending
              ? this.statusStatisticData.pending
              : 0
        },
        {
          text: 'Answered',
          value:
            this.statusStatisticData && this.statusStatisticData.answered
              ? this.statusStatisticData.answered
              : 0
        },
        {
          text: 'Closed with survey',
          value:
            this.statusStatisticData && this.statusStatisticData.closed_with_survey
              ? this.statusStatisticData.closed_with_survey
              : 0
        },
        {
          text: 'Closed without survey',
          value:
            this.statusStatisticData && this.statusStatisticData.closed_without_survey
              ? this.statusStatisticData.closed_without_survey
              : 0
        },
        {
          text: 'Cancelled by customer',
          value:
            this.statusStatisticData && this.statusStatisticData.cancelled_by_customer
              ? this.statusStatisticData.cancelled_by_customer
              : 0
        },
        {
          text: 'Closed by system',
          value:
            this.statusStatisticData && this.statusStatisticData.closed_by_system
              ? this.statusStatisticData.closed_by_system
              : 0
        }
      ]
    }
  },
  methods: {
    resolvedBackGroundColor(item) {
      return (
        {
          Pending: '#FFE5B7',
          Answered: '#CBE3FF',
          'Closed with survey': '#D4F2E1',
          'Closed without survey': '#DFF5CA',
          'Cancelled by customer': '#FFD6D6',
          'Closed by system': '#E4E8EC'
        }[item.text] || '#fff'
      )
    }
  }
}
</script>
<style lang="css" scoped>
/* .resize-header {
  font-size: 16px !important;
  font-weight: 400;
}
.resize-value {
  font-size: 24px !important;
  line-height: 32px !important;
}
@media screen and (min-width: 1560px) { */
.resize-header {
  font-size: 24px !important;
  text-align: center !important;
  justify-content: center !important;
}
.resize-value {
  text-align: center;
  font-size: 56px !important;
  font-weight: bold !important;
}
/* } */
</style>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/Overview/StatusStatistics.vue